import { render, staticRenderFns } from "./promotions_page.vue?vue&type=template&id=2b0a4aae&"
import script from "./promotions_page.vue?vue&type=script&lang=js&"
export * from "./promotions_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports